import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-component-videoembed-thumbnail',
  template: `
    <a *ngIf="thumbnailsrc" [href]="'https://www.vimeo.com/' + url" target="_blank">
      <img [src]="thumbnailsrc" class="img-fluid" />
    </a>
  `,
  styleUrls: ['./component-videoembed-thumbnail.component.scss']
})
export class ComponentVideoembedThumbnailComponent implements OnChanges {
  @Input() url: string = '';
  thumbnailsrc = '';

  constructor(private _http: HttpClient) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['url'] && this.url) {
      this.loadThumbnail(this.url);
    }
  }

  private loadThumbnail(videoCode: string): void {
    const apiUrl = `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoCode}`;
    this._http.get<{ thumbnail_url: string }>(apiUrl)
      .pipe(
        catchError(err => {
          console.error('Failed to fetch Vimeo thumbnail:', err);
          return of({ thumbnail_url: '' });
        })
      )
      .subscribe(response => {
        this.thumbnailsrc = response.thumbnail_url;
      });
  }
}
